export default "__VITE_ASSET__Csy40ti2__"